export default "__VITE_ASSET__Dpa_tRq9__"